/**
 * useLeaveCalendar — React Query hook csapat szabadság naptár lekérdezéséhez
 */

import { useQuery } from '@tanstack/react-query';
import { getLeaveCalendar, type LeaveRequest } from '../api/hr-api';

export function leaveCalendarQueryKey(year: number, month: number) {
  return ['hr', 'leave', 'calendar', year, month] as const;
}

export function useLeaveCalendar(year: number, month: number) {
  return useQuery<LeaveRequest[]>({
    queryKey: leaveCalendarQueryKey(year, month),
    queryFn: async () => {
      const res = await getLeaveCalendar(year, month);
      return res.data;
    },
    staleTime: 30_000,
  });
}
